<template>
	<div grey-back full-height>

		<v-toolbar flat fixed>
		    <v-toolbar-side-icon @click="fn_goBack"><v-icon>arrow_back</v-icon></v-toolbar-side-icon>

		    <v-toolbar-title class="white--text">Tax Category</v-toolbar-title>

		   <!--  <v-spacer></v-spacer>

		    <v-btn round-borders outline @click="fn_checkValidations">save</v-btn> -->

		    <!-- <v-btn icon @click="fn_getBottomMenu">
		      <v-icon>more_vert</v-icon>
		    </v-btn> -->
		</v-toolbar>

		<v-form class="form-element hasToolbar hasFooter grey-back">

			<!-- <v-alert :value="true" color="info" class="draft-items-info" transition="slide-y-transition" v-if="Form.draftItems && Form.draftItems.length"@click="fn_openDialogDraftItems">
				<span>Draft Items</span>
				<span class="right-side-content">{{Form.draftItems.length}}</span>
			</v-alert> -->

			<!-- <v-alert :value="loadedFromDraft" type="info" icon="info" transition="slide-y-transition">
				<span>Item loaded from draft.</span>
			</v-alert> -->

			<v-layout wrap padding-top-bottom-ten white-background>

					<v-flex xs12 sm12 md12 form-item>
		               <v-text-field v-model="Form.name" label="Name" placeholder=" " v-validate="'required|max:50'" :error-messages="errors.collect('name')" data-vv-name="name" required></v-text-field>
		            </v-flex>
		            
		            <v-flex xs12 sm12 md12 form-item>
		               <v-text-field  type="number" v-model="Form.taxValue" label="Tax (Percentage)" placeholder=" " v-validate="'required|min_value:0|decimal:2'" :error-messages="errors.collect('tax')" data-vv-name="tax" data-vv-as="tax (percentage)"></v-text-field>
		            </v-flex>

		            <v-checkbox label="Cess Applicable" v-model="Form.isCessApplicable" form-item></v-checkbox>

		            <v-flex xs12 sm12 md12 form-item v-if="Form.isCessApplicable && $root.appVersion < 285">
		               <v-text-field  type="number" v-model="Form.cessValue" label="Cess (Percentage)" placeholder=" " v-validate="'required|min_value:0|decimal:2'" :error-messages="errors.collect('cess')" data-vv-name="cess" data-vv-as="cess (percentage)"></v-text-field>
		            </v-flex>

					<template v-if="Form.isCessApplicable && $root.appVersion >= 285">
						<v-flex xs12 sm12 md12 form-item>
							<v-select
								:items="cessTypes"
								placeholder=" "
								v-model="Form.cessTypeObj"
								@input="fn_changeCessType"
								label="Cess Type"
								item-text="title"
								item-value="value"
								return-object
							></v-select>
						</v-flex>

						<!-- <v-flex xs12 sm12 md12 form-item id="cess_percent">
							<v-text-field  
								type="number" 
								v-model="Form.cessValue" 
								label="Cess Percentage" 
								placeholder=" " 
								v-validate="'required|min_value:0|decimal:2'" 
								data-vv-name="cess" 
								name="cess"
								data-vv-as="cess precentage"
								:error-messages="errors.collect('cess')">
							</v-text-field>
						</v-flex> -->

						<v-flex xs12 sm12 md12 form-item id="cess_percent">
							<v-text-field  
								v-if="Form.cessTypeObj && Form.cessTypeObj.value != 2"
								type="number" 
								v-model="Form.cessValue" 
								label="Cess Percentage" 
								placeholder=" " 
								v-validate="'required|decimal:2|min_value:0.01'" 
								data-vv-name="cess" 
								name="cess"
								data-vv-as="cess precentage"
								:error-messages="errors.collect('cess')">
							</v-text-field>
						</v-flex>

						<v-flex xs12 sm12 md12 form-item v-if="Form.cessTypeObj && Form.cessTypeObj.value != 1">
							<v-text-field  
								type="number" 
								v-model="Form.cessValueOnQuantity" 
								label="Cess Value (Per Qty)" 
								placeholder=" " 
								v-validate="'required|min_value:0.01|decimal:2'" 
								data-vv-name="cess_value" 
								name="cessqty"
								data-vv-as="cess value"
								:error-messages="errors.collect('cess_value')">
							</v-text-field>
						</v-flex>
					</template>

					<!-- <template v-if="Form.isCessApplicable">

						<v-flex xs12 sm12 md12 form-item id="cess_qty">

							<v-text-field  
								v-if="Form.cessTypeObj && Form.cessTypeObj.value != 1"
								type="number" 
								v-model="Form.cessValueOnQuantity" 
								label="Cess Value (Per QTY)" 
								placeholder=" " 
								v-validate="'required|min_value:0|decimal:4'" 
								data-vv-name="cess_value" 
								name="cess_value"
								data-vv-as="cess value"
								:error-messages="errors.collect('cess_value')">
							</v-text-field>
						</v-flex>
					</template> -->

			</v-layout>

			<div style="position:fixed;bottom:0" full-width>
				<v-btn noroundborders color="primary" block nomargin class="height48" @click="fn_checkValidations" style="border-radius:0;">Save</v-btn>
			</div>

		</v-form>

	    <v-dialog v-model="loading" no-click-animation persistent max-width="290">
	      <v-card>
	        <v-card-text class="align_vertical_middle">
	          <v-progress-circular indeterminate color="primary"></v-progress-circular> Please wait...
	        </v-card-text>
	      </v-card>
	    </v-dialog>

	    <!-- fn_draftAction is in draft mixin -->
	    <dialog-discard ref="ref_dialogDiscard" :draftAction="fn_draftAction" :save="fn_checkValidations" :hideKeepDraft="true"></dialog-discard>

	    <!-- <dialog-draft-items ref="ref_dialogDraftItems" :draftItems="Form.draftItems" :importDraft="fn_importDraft" :removeDraftItem="fn_removeDraftItem"></dialog-draft-items> -->

	    <v-snackbar v-model="snackbar" :timeout="2000">{{snackbar_msg}}</v-snackbar>

	</div>
</template>

<script>

const dialogjs =  require('../dialog').dialogjs;
const menuItem = require('../../../../config.js').configs.menuItem;

import dialogDiscard from '../../../dialogs/dialog_discard'
import {draftMixin} from '../../../draft_mixin'
// import dialogDraftItems from '../../../dialogs/dialog_draft_items'


	export default{
		mixins: [draftMixin],
		data(){
			return{
				Form:{"taxCategoryId":null, "name":null, "taxValue":null, "isCessApplicable":false, "cessValue":null, "isSystem":0, "draftItems":[], "createdDate":null, "modifiedDate":null, "cessTypeObj":{"title":"Percentage on Value", "value":1}, "cessValueOnQuantity":null},

				loading:false,
				tagId:null,
				dialogStorageId:null,
				draftStorageId:null,

				backButtonPress:false,

				snackbar:false,
				snackbar_msg:null,

				unwatch:false,
				cessTypes:[
					{"title":"Percentage on Value", "value":1},
					{"title":"Value on Quantity", "value":2}, 
					{"title":"Percentage on Value and Quantity", "value":3}
				]
				// loadedFromDraft:false
			}
		},
		watch:{
			'Form': {
                handler: function (newVal, oldVal){
                    if(!this.unwatch){
                     	this.fn_saveDraft(this.Form.name);
                     }
                     this.unwatch = false;
                },
                deep: true
            }
		},
		components:{
			'dialog-discard': dialogDiscard,
			// 'dialog-draft-items': dialogDraftItems
		},
		methods:{

			fn_openDialogDiscard: function(){
				this.fn_openDialogWeb('web', 'Discard', 'ref_dialogDiscard')
			},

			fn_openDialogWeb: function (platform, name, ref) {

				let scroll_y = window.scrollY;
				this.fn_fixBackgroundScroll();

				var tagId = this.guidWeb();

				var dialogObj = {};
				dialogObj.tagId = tagId;
				dialogObj.formId = this.formId;
				dialogObj.name = name;
				dialogObj.ref = ref;
				dialogObj.data = null;
				dialogObj.platform = platform;

				dialogObj.scrollPosition = {};
				dialogObj.scrollPosition.x = 0;
				dialogObj.scrollPosition.y = scroll_y;

				dialogjs.fn_pushDialogInStack(this.dialogStorageId, dialogObj, this);

				this.$refs[ref].openDialogWeb();
			},

			fn_closeDialog(){
				dialogjs.fn_checkAndCloseOpenDialogs(this);
			},

			// fn_getBottomMenu: function (tagId) {
			// 	var bottomMenu = {"BottomMenu": [menuItem.save, menuItem.reset, menuItem.help]};
			// 	this.setBottomMenu(tagId, bottomMenu, 
			// 		{
			// 			onSuccess: function (response) {
			// 				console.log(response);
			// 			},
			// 			onError: function (error) {
			// 				console.log(error);
			// 			}
			// 		}
			// 	)
			// },

			fn_checkValidations: function(){
				var self = this;
			      this.$validator.validateAll().then((result) => {
			        if (result) {
			           self.fn_post();
			          	return; 
			        }
			        else{
			        	this.$vuetify.goTo('.error--text', this.scrollOptions);
			        }
			        self.loading = false;
			     });
			},
			
			fn_saveLocal: function(dataObj){
				var self = this;
				this.postData('TaxCategory', dataObj, 
					{
						onSuccess: function(response){
				          console.log(response);
				          let status = JSON.parse(response);
				          if(status) {
				          	self.fn_cleanUp();
				          }
				          else {
				          	// self.snackbar = true;
				          	// self.snackbar_msg = "Already exists with this name";
				          	self.showToast("Already exists with this name");
				          }
				        },
				        onError: function(error){
				          console.log(error);
				        }
					}
		        );
			},

			fn_cleanUp: function () {

				// this.loadedFromDraft = false;

				if(this.$route.query.ls){
					let data = {};
					data.type = this.$route.query.new ? 'newTaxCategory' : 'taxCategory';
					data.taxCategoryId = this.Form.taxCategoryId;
					data.taxCategoryName = this.Form.name;
					data.taxValue = this.Form.taxValue;
					data.cessValue = this.Form.cessValue;
					data.isCessApplicable = this.Form.isCessApplicable;
					data.cessValueOnQuantity = this.Form.cessValueOnQuantity;
					localStorage.setItem('newItem', JSON.stringify(data));
					localStorage.setItem('closeDialog', 1);
				}

				let self = this;
				this.fn_removeDraft(this.draftStorageId, function(){
					self.$router.go(-1);
				});
			},
			
			fn_post: function(){

				// !this.Form.taxCategoryId ? this.Form.taxCategoryId = this.guid() : '';
				if(!this.Form.taxCategoryId){
					this.Form.taxCategoryId = this.guid();
					// this.Form.createdDate = new Date();
					this.Form.createdDate = this.$root.fn_getLocalDateFormat();
				}

				// this.Form.modifiedDate = new Date();
				this.Form.modifiedDate = this.$root.fn_getLocalDateFormat();
				
				this.Form.name = this.Form.name.trim();
				// !this.Form.isCessApplicable ? this.Form.cessValue = null : '';

				if(this.Form.isCessApplicable && this.Form.cessTypeObj){
					this.Form.cessType = this.Form.cessTypeObj.value;
					if(this.Form.cessType == 1){
						this.Form.cessValueOnQuantity = null;
					}
					else if(this.Form.cessType == 2){
						this.Form.cessValue = null;
					}
				}
				else{
					this.Form.cessValue = null;
				}

				console.log(this.Form);
				this.fn_saveLocal(this.Form);
			},

			fn_get: function(itemId, copyData){
				var self = this;
				this.getData('TaxCategory', itemId, 
					{
						onSuccess: function(response){
				          	console.log(response);
				          	self.unwatch = true;
				          	self.Form = JSON.parse(response);

							if(self.Form.isCessApplicable){
								if(self.Form.cessType == undefined || self.Form.cessType == 1){
									self.Form.cessTypeObj = {"title":"Percentage on Value", "value":1};
								}
								else if(self.Form.cessType == 2){
									self.Form.cessTypeObj = {"title":"Percentage on Quantity", "value":2};
								}
								else{
									self.Form.cessTypeObj = {"title":"Percentage on Value and Quantity", "value":3};
								}
							}
				          	
				          	if(copyData){
				          		self.Form.taxCategoryId = null;
				          		self.Form.isSystem = 0;
				    //       		self.snackbar = true;
								// self.snackbar_msg = "Data copied."
								self.showToast("Tax Category copied");
				        	}

				        	self.$root.fn_copyFormObject(self.Form, self.formId);
				        }, 
				        onError: function(error){
				          console.log(error);
				        }
					}
		        );
			},
			
			fn_clearForm: function(){
				this.Form = {"taxCategoryId":null, "name":null, "taxValue":null, "isCessApplicable":false, "cessValue":null, "isSystem":0, "draftItems":[], "createdDate":null, "modifiedDate":null};
				this.$validator.reset();
			},
			
			fn_menuItemClick: function(tagId, menuId, menuAction){
				// tagId id form future use
				// menuId id form future use
				this.backButtonPress = false;

				if(menuAction=='save'){
					this.fn_checkValidations();
				}
				else if(menuAction=='reset'){
					this.fn_resetForm();
				}
			},

			fn_resetForm: function () {
				this.unwatch = true;
				// this.loadedFromDraft = false;

				if(this.Form.taxCategoryId){
					this.fn_get(this.Form.taxCategoryId);
				}
				else{
					this.fn_clearForm();
				}
				
				let self = this;
				this.fn_removeDraft(this.draftStorageId, function(){
					console.log("draft deleted");
					// self.showToast("Item deleted from draft");
				});
			},
			
			fn_showWebView: function () {
				var viewObject = {};
				viewObject.ToolbarTitle = "Tax Category";
				viewObject.TopMenu = [menuItem.save];
				viewObject.isBottomMenu = true;
				var tagId = this.formId;
				var self = this;
				this.showWebView(tagId, viewObject, 
					{
						onSuccess: function(response){
				          console.log(response);
				        }, 
				        onError: function(error){
				          console.log(error);
				        }, 
				        // onChange: null,
				        onMenuItemClick: function (tagId, menuId, menuAction) {
							self.fn_menuItemClick(tagId, menuId, menuAction)
						}
					}
				);
			},

			fn_changeCessType: function(obj){
				this.Form.cessTypeObj = {};
				this.Form.cessTypeObj.title = obj.title;
				this.Form.cessTypeObj.value = obj.value;
				this.$validator.reset();
				this.$forceUpdate();
			},
			
			fn_goBack: function(){
				this.backButtonPress = true;
				this.$router.go(-1);
			}
		},
		mounted: function(){

			var self = this;

			if(this.$route.query && this.$route.query.tagId){//in case of new form
				this.formId = this.$route.query.tagId;
				this.draftStorageId = 'draft_master_'+this.formId;
				this.dialogStorageId = 'dialog_'+this.formId;
			}
			else if(this.$route.params && this.$route.params.tagId){//in case of edit form
				this.formId = this.$route.params.tagId;
				this.draftStorageId = 'draft_master_'+this.formId;
				this.dialogStorageId = 'dialog_'+this.formId;
			}

			// this.dialogStorageId = 'dialog_'+this.formId;

			var formsArray = [];
			if(localStorage.getItem('taxcategoryforms')){
				formsArray = JSON.parse(localStorage.getItem('taxcategoryforms'));
			}

			formsArray.push(this.formId);
			localStorage.setItem('taxcategoryforms', JSON.stringify(formsArray));


			window.js_globals.fn_onBackPress = this.fn_goBack;
			window.js_globals.fn_closeClick = this.fn_closeDialog;
			// window.js_globals.fn_getBottomMenu = this.fn_getBottomMenu;

			
			this.fn_showWebView();
			dialogjs.fn_checkAndShowOpenDialogs(this);

			if((this.$route.query && this.$route.query.tagId) || (this.$route.params && this.$route.params.tagId)){

				this.fn_setFormDataFromDraft(function(draft){

					if(draft){
						self.Form = JSON.parse(draft.formData);

			            // if((self.$route.query && self.$route.query.draft) || (self.$route.params && self.$route.params.tagId)){
			            //   self.loadedFromDraft = true;
			            // }
					}

					// self.$route.query.tagId ? self.fn_checkDraftItems('Tax Category', true) : '';

				});

			}

			let formElement = document.getElementsByClassName("form-element")[0];

			formElement.addEventListener("submit", function(e){
			    e.preventDefault();
			});

			// this.fn_setDraftData('Master', 'Tax Category');
			this.fn_setDraftData('temp', 'Tax Category');

		},
		beforeRouteEnter (to, from, next) {
		  	next(vm => {
		  		vm.enableToolbar();
		  		
		  		let itemId = null;
		  		let copyData = false;

		  		//edit from display view 
		  		if((from.params && from.params.tagId) && (to.query && !to.query.tagId)){
					itemId = from.params.tagId;  			
		  		}

		  		//edit from list view
		  		else if(from.name=='taxCategoryItems' && (to.params && to.params.tagId)){
		  			itemId = to.params.tagId;
		  		}

		  		//copy data
		  		if(to.query && to.query.copy){
		  			if(from.name == 'taxCategoryItems'){ //copy from list view
		  				itemId = to.query.itemId;
		  			}
		  			else if(from.name == 'taxCategoryDisplay'){ //copy from display view
		  				itemId = from.params.tagId;
		  			}
		  			copyData = true;
		  		}

		  		//checking if draft exist
		  		// vm.fn_isDraft(function(isDraft){
		  		// 	if(itemId && !isDraft){
		  		// 		vm.fn_get(itemId, copyData);
		  		// 	}
		  		// })

		  		if(itemId){
	  				vm.fn_get(itemId, copyData);
	  			}
	  			else{
					vm.$root.fn_copyFormObject(vm.Form, vm.formId); 				
	  			}

		  		// !itemId ? vm.$root.fn_copyFormObject(vm.Form, vm.formId) : '';

		  	})
		},
		beforeRouteUpdate (to, from, next) {

			this.enableToolbar();
			
			var dialogData = JSON.parse(localStorage.getItem(this.dialogStorageId));
			var existingForm = false;
			if(dialogData && dialogData.length){
				var openForms = JSON.parse(localStorage.getItem('taxcategoryforms'));
				for(var i=0; i<openForms.length; i++){
					if(openForms[i]==to.query.tagId){
						existingForm = true;
						dialogjs.fn_checkAndCloseOpenDialogs(this);
						break;
					}
				}
				existingForm ? next(false) : next(true);
			}
			else{
				next();
			}
	    },
		beforeRouteLeave (to, from, next) {
			var dialogData = JSON.parse(localStorage.getItem(this.dialogStorageId));
			if(dialogData && dialogData.length){

				if(this.backButtonPress){
					dialogjs.fn_checkAndCloseOpenDialogs(this);
					next(false);
				}
				else{
					// this.$root.fn_deleteFormObject();
					this.fn_saveDraft(this.Form.name);
					next(true);
				}
			}
			else{
				if(this.fn_showDialogDiscard()){
					this.fn_openDialogDiscard();
					next(false);
				}
				else{
					this.fn_clearData('taxcategoryforms', function(){
						next();
					})
				}
				// if(this.loadedFromDraft || (this.$root.fn_getFormObject(this.formId) && !this.$root.fn_deepEqual(this.Form, JSON.parse(this.$root.fn_getFormObject(this.formId))))){
				// 	this.fn_openDialogDiscard();
				// 	next(false);
				// }
				// else{
				// 	this.$root.fn_deleteFormObject(this.formId);
				// 	!this.askToDiscard ? this.fn_removeDraft(this.draftStorageId, null, -1) : '';
				// 	localStorage.removeItem('taxcategoryforms');
				// 	next();	
				// }
			}
	    }

	}

</script>


// WEBPACK FOOTER //
// src/components/masters/forms/tax_category/form.vue